<h2 mat-dialog-title>Réinitialisation de votre mot de passe</h2>
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <p>Veuillez indiquer l'adresse e-mail de votre compte ci-dessous. Vous recevrez un e-mail avec un lien vous permettant de modifier votre mot de passe.</p>
    <mat-form-field class="full-width">
      <mat-label>Email</mat-label>
      <input type="email" matInput formControlName="email" [value]="data?.email"/>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="mt5 mb5 text-center">
    <button type="button" mat-button [mat-dialog-close]>Annuler</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="!resetPasswordForm.valid">Valider</button>
  </div>
</form>
